import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  suggestModalSetIsLoadingReducerType,
  suggestModalSetIsNextPageLoadingReducerType,
  suggestModalSetOpModelReducerType,
  suggestModalSetNoDataReducerType,
  suggestModalSetCurrentDBReducerType,
  suggestModalSetHighlightedItemReducerType,
  suggestModalSetCurrentPageReducerType,
  suggestModalSetExpandedValueReducerType,
  suggestModalSetFullUpdateReducerType,
  suggestModalSetSuggestConfigReducerType,
} from './SuggestModalConstants';

export const initialState = Map({
  isLoading: false,
  isNextPageLoading: false,
  opModel: {
    title: null,
    selection: [],
    groups: [],
  },
  noData: false,
  currentDB: null,
  highlightedItem: null,
  currentPage: 1,
  expandedValue: '',
  fullUpdate: true,
  suggestConfig: null,
});

const spec = {
  [suggestModalSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [suggestModalSetIsNextPageLoadingReducerType]: (state, action) => {
    const { isNextPageLoading } = action.payload;
    return state.set('isNextPageLoading', isNextPageLoading);
  },
  [suggestModalSetOpModelReducerType]: (state, action) => {
    const { opModel } = action.payload;
    return state.set('opModel', opModel);
  },
  [suggestModalSetNoDataReducerType]: (state, action) => {
    const { noData } = action.payload;
    return state.set('noData', noData);
  },
  [suggestModalSetCurrentDBReducerType]: (state, action) => {
    const { currentDB } = action.payload;
    return state.set('currentDB', currentDB);
  },
  [suggestModalSetHighlightedItemReducerType]: (state, action) => {
    const { highlightedItem } = action.payload;
    return state.set('highlightedItem', highlightedItem);
  },
  [suggestModalSetCurrentPageReducerType]: (state, action) => {
    const { currentPage } = action.payload;
    return state.set('currentPage', currentPage);
  },
  [suggestModalSetExpandedValueReducerType]: (state, action) => {
    const { expandedValue } = action.payload;
    return state.set('expandedValue', expandedValue);
  },
  [suggestModalSetFullUpdateReducerType]: (state, action) => {
    const { fullUpdate } = action.payload;
    return state.set('fullUpdate', fullUpdate);
  },
  [suggestModalSetSuggestConfigReducerType]: (state, action) => {
    const { suggestConfig } = action.payload;
    return state.set('suggestConfig', suggestConfig);
  },
};

export default createReducerBySpec(spec, initialState);
